import axios from 'axios'

import { ApiService } from './api.service'
import LocalStorageKeys from '../data/localStorageKeys'

export class ComercianteService extends ApiService {
  static get AuthHeader() {
    return 'Bearer ' + localStorage.getItem(LocalStorageKeys.tokenComercio);
  }

  static get Headers() {
    return {
      Authorization: this.AuthHeader,
    };
  }

  /**
   *
   * @returns {Promise<import("axios").AxiosResponse<{dias: string, porcentajeDescuento: number}[]>>}
   */
  static getDescuentos() {
    return axios.get(this.api + 'comerciante/descuento', {
      headers: this.Headers,
    });
  }

  static getVenta(idVenta) {
    return axios.get(this.api + 'venta/' + idVenta, {
      headers: this.Headers,
    });
  }

  /**
   * 
   * @param {*} filterDto 
   * @returns {Promise<import("axios").AxiosResponse<
   * {list: {id, fecha, nombreCliente, porcentajeDescuento, precioBase }[],
   *  totalCobrado: number, totalDescontado: number}
   * >>}
   */
  static getVentaListAndTotalsWithFilter(filterDto) {
    return axios.post(this.api + 'venta/comerciante/filter/withTotals', filterDto, { headers: this.Headers });
  }
}
